// tokenReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	completedSitesLoading: false,
};

const completedSitesLoading = createSlice({
	name: 'completedSitesLoading', // Use the same name as in your store configuration
	initialState,
	reducers: {
		setCompletedSitesLoading: (state, action) => {
			state.completedSitesLoading = action.payload;
		},
	},
});

export const { setCompletedSitesLoading } = completedSitesLoading.actions;
export default completedSitesLoading.reducer;
